function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import FullParagraphAdvancedFieldsConfig from "segments/desktop/core-components/full-paragraph/fields-config";
const { buttonTopMargin, textColor, topicBottomMargin, buttonConfig, assetUnderParagraph } = FullParagraphAdvancedFieldsConfig, restOfParagraphConfig = _object_without_properties(FullParagraphAdvancedFieldsConfig, [
    "buttonTopMargin",
    "textColor",
    "topicBottomMargin",
    "buttonConfig",
    "assetUnderParagraph"
]);
export default {
    type: FIELD_TYPES.NESTED,
    label: "Get A Call",
    fields: {
        howToConnectParagraph: {
            type: FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: restOfParagraphConfig
        },
        getCallButtonText: {
            type: FIELD_TYPES.TEXT,
            label: 'Get a call button text',
            defaultValue: "Get a call now"
        },
        setMeetingButtonText: {
            type: FIELD_TYPES.TEXT,
            label: 'Book a meeting button text',
            defaultValue: "Book a meeting"
        },
        setMeetingUrl: {
            type: FIELD_TYPES.TEXT,
            label: 'url to redirect for book a meeting',
            defaultValue: "/sales/book-a-meeting"
        },
        getCallThankYouUrl: {
            type: FIELD_TYPES.TEXT,
            label: 'url to redirect after get a call click',
            defaultValue: "/sales/thank-you-get-call"
        }
    }
};
